import { LogoBuilderActionTypes } from './logoBuilder.types';

const logoBuilderAvailabilityRequest = () => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_AVAILABILITY_REQUEST });
const logoBuilderAvailabilitySuccess = () => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_AVAILABILITY_SUCCESS });
const logoBuilderAvailabilityFailure = () => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_AVAILABILITY_FAILURE });
const logoBuilderAvailabilitySet = payload => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_AVAILABILITY_SET, payload });
const logoBuilderLoading = payload => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_LOADING, payload });

const logoBuilderLogoGenerationRequest = payload => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_LOGO_GENERATION_REQUEST, payload });
const logoBuilderLogoGenerationSuccess = () => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_LOGO_GENERATION_SUCCESS });
const logoBuilderLogoGenerationFailure = () => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_LOGO_GENERATION_FAILURE });

const logoBuilderClickedOnMenu = () => ({ type: LogoBuilderActionTypes.LOGO_BUILDER_CLICKED_ON_MENU });


const actions = {
  availability: {
    request: logoBuilderAvailabilityRequest,
    success: logoBuilderAvailabilitySuccess,
    failure: logoBuilderAvailabilityFailure,
    set: logoBuilderAvailabilitySet,
  },
  logoGeneration: {
    request: logoBuilderLogoGenerationRequest,
    success: logoBuilderLogoGenerationSuccess,
    failure: logoBuilderLogoGenerationFailure,
  },
  loading: logoBuilderLoading,
  clickedOnMenu: logoBuilderClickedOnMenu,
};

export default actions;
